<template>
  <div v-if="term" class="term border-radius">
    <div class="main-container padding-l" style="height: 100%">
      <div class="flex-column margin-l-bottom" style="height: 100%">
        <div class="term-content">
          <h3
            class="text-center margin-auto-inline text-bold text-l margin-m-bottom text-overflow-ellipsis">
            {{ term.title }}
          </h3>
          <p v-show="!isExpanded" class="animate__fadeIn animate--fast">{{ term.shortDescription }}</p>
          <p v-show="isExpanded" class="animate__fadeIn animate--fast">
            {{ term.content }}
          </p>

        </div>
        <div class="description-control text-l text-bold" style="margin-top: auto">
          <form-button
            v-show="!isExpanded"
            size="s"
            icon-end="chevron-inline-end"
            text="ag.term.showMore"
            @click.prevent.stop="isExpanded = !isExpanded"
          ></form-button
          >
          <form-button
            v-show="isExpanded"
            size="s"
            text="ag.term.showLess"
            icon-end="chevron-up"
            @click.prevent.stop="isExpanded = !isExpanded"
          ></form-button
          >
        </div>
        <div class="term-footer" >
          <hr class="margin-l-top" />
          <div class="flex-between flex-wrap gap-m">
            <div class="term-field">
              <strong>{{tu('ag.term.country')}}:</strong>
              <span>&nbsp;</span>
              <span v-if="term.country">{{ term.country }}</span>
              <span v-else>-</span>
            </div>
            <div class="term-field">
              <strong>{{tu('ag.term.company')}}:</strong>
              <span>&nbsp;</span>
              <span v-if="term.company">{{ term.company }}</span>
              <span v-else>-</span>
            </div>

            <div class="term-field full" v-if="term.linkTarget && term.linkTarget !== ''">
              <div class="term-field">
                <strong>{{tu('ag.term.link')}}:</strong>
                <span>&nbsp;</span>
                <a :href="term.linkTarget" target="_blank">
                  <span v-if="term.linkText">{{ term.linkText }}</span>
                  <span v-else>{{ t('ag.term.defaultLinkText') }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    term: {
      type: [Object, Boolean],
      default: false,
    },
  },
  data: function () {
    return {
      isExpanded: false,
    };
  },
};
</script>

<style scoped lang="scss">


.term-extra {
  padding: var(--margin-s) var(--margin-l) var(--margin-l) var(--margin-l);
  border-top: 1px solid var(--c-gray);
  background: var(--c-gray-1);
  border-start-start-radius: 0;
  border-start-end-radius: 0;
  border-end-start-radius: var(--border-radius);
  border-end-end-radius: var(--border-radius);

  a {
    text-decoration: underline;
    color: var(--c-lead-5);

    &:hover {
      color: var(--c-lead-4);
    }
  }
}

.term-field {
  flex: 100%;

  @media (min-width: 1024px) {
    flex: calc(50% - 1 / 2 * var(--margin-m));

    &.full {
      flex: 100%;
    }
  }
}
</style>
